module.exports = __webpack_public_path__ + "media/3d-GIS-3.0f515149.mp4";